export default {"src":"__ASTRO_ASSET_IMAGE__B8857$rY__","width":256,"height":256,"format":"png"}